import { render, staticRenderFns } from "./HighlightText.vue?vue&type=template&id=c9777818&"
import script from "./HighlightText.vue?vue&type=script&lang=js&"
export * from "./HighlightText.vue?vue&type=script&lang=js&"
import style0 from "./HighlightText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports